export default __webpack_public_path__ + "static/bubble_contact-c6e38b7465c264464e99aeb33724efd8.jpg";